import styled from "styled-components";
import { HeaderText } from "./Text";

export default styled(HeaderText)`
  font-size: 24px;
  color: ${({ theme }) => theme.color.text.light};
`;
